export default {
    resalesLanding: {
        sentOn: "Envoyé le",
        toggleContact: "Afficher/masquer le contact de l'agence",
        propertyOffers: "Offres de biens",
        openGallery: "Ouvrir la galerie photos",
        prevPhoto: "Photo précédente",
        nextPhoto: "Photo suivante",
        close: "Fermer",
        photo: "Photo",
        description: "Description",
        more: "Plus",
        less: "Moins",
        intFloorSpace: "Surface utile",
        build: "Construit",
        terrace: "Terrasse",
        garden: "Jardin",
        buildYear: "Année de construction",
        fees: "Frais",
        communityFees: "Charges de copropriété",
        basuraTax: "Taxe sur les ordures (Basura)",
        ibiFees: "IBI (taxe foncière)",
        securityDeposit: "Dépôt de garantie",
        perMonth: "/mois",
        perWeek: "/semaine",
        disclaimer: "Avertissement",
        energyCertificate: "Certificat énergétique",
        pending: "En attente",
        rating: "Classement",
        presentedBy: "Présenté par",
        propertyDetails: "Détails du bien",
        reference: "Référence",
        referenceShort: "Réf",
        unitUnavailable: "Plus disponible",
        availableUnits: "Unités disponibles et prix",
        availableUnitsShort: "Unités disponibles",
        unit: "Unité",
        type: "Type",
        floors: "Étages",
        bedrooms: "Ch.",
        bathrooms: "SdB",
        surfaceArea: "Intérieur",
        price: "Prix",
        status: "Statut",
        unitAvailable: "Disponible",
        unitReserved: "Réservé",
        unitSold: "Vendu",
        seeMore: "Voir plus",
        seeLess: "Voir moins",
        floor: "Étage",
        storeys: "Niveaux",
        keyReady: "Clés en main",
        touristLicence: "Licence touristique",
        firstOccupationLicence: "Licence de première occupation",
        notKnown: "Non connu",
        notProvided: "Non renseigné",
        yes: "Oui",
        no: "Non",
        mortgageAvailable: "Financement possible",
        guaranteedRental: "Location garantie",
        sellBeforeCompletion: "Cession du contrat avant achèvement",
        sellBeforeCompletionYes: "Autorisée",
        sellBeforeCompletionNo: "Non autorisée",
        sellBeforeCompletionNotProvided: "Non renseigné",
        reservation: "Réservation",
        contract: "Contrat",
        construction: "Construction",
        completion: "Achèvement",
        co2: "CO2",
        energyConsumption: "Consommation d'énergie",
        co2PerYear: "kg CO2/an",
        kwhPerYear: "kWh/an",
        features: "Caractéristiques",
        viewDetails: "Voir les détails",
        hideDetails: "Masquer les détails du bien",
        backToResults: "Résultats",
        viewProperty: "Voir le bien",
        prevProperty: "Précédent",
        nextProperty: "Suivant",
        viewAllFeatures: "Voir toutes les caractéristiques",
        allFeatures: "Toutes les caractéristiques",
        infoOnRequest: "Informations sur demande",
        tbc: "A.C.",
        featureCategoryLabels: { pool: "Piscine", views: "Vues", parking: "Parking", kitchen: "Cuisine", condition: "État", garden: "Jardin" },
        featureQualifierFormat: "{category} {value}",
        location: "Emplacement",
        agencyInformation: "Informations sur l'agence",
        buyingCosts: "Frais d'acquisition",
        propertyPrice: "Prix du bien :",
        priceNote: "**Le prix ne comprend ni les taxes ni les frais d'acquisition.",
        estimatedPurchaseCosts: "Frais d'acquisition estimés :",
        hide: "Masquer",
        showBreakdown: "Afficher le détail des frais d'acquisition",
        purchaseCostBreakdown: "Détail des frais d'acquisition",
        concept: "Poste",
        application: "Application",
        rowTransferTax: "ITP (droits de mutation, bien de revente)",
        rowVat: "TVA (construction neuve)",
        rowVatLand: "TVA",
        vatApplication: "10 % (4 % pour le logement protégé)",
        rowStampDuty: "Droit de timbre (AJD)",
        rowNotary: "Notaire",
        rowLandRegistry: "Registre foncier",
        officialTariff: "Tarif officiel",
        costRangeNotePrefix: "*Le total des frais à la charge de l'acquéreur se situe généralement entre",
        and: "et",
        ofPurchasePrice: "du prix d'achat.",
        costApproxNote: "*Les frais d'achat estimés sont fournis à titre indicatif uniquement. Les frais réels peuvent varier en fonction du bien et de la situation de l'acheteur. Nous recommandons de consulter un professionnel pour un calcul exact.",
        additionalInformation: "Informations complémentaires",
        addInfoDocument: "*Document d'information abrégé disponible conformément au décret andalou 218/2005",
        addInfoNoFees: "*L'acquéreur ne paie pas de frais d'agence immobilière",
        formHeading: "Souhaitez-vous en savoir plus sur les prix et le bien ?",
        firstName: "Prénom",
        enterNumber: "Saisir le numéro",
        email: "E-mail",
        searchCountry: "Rechercher un pays ou un indicatif",
        noMatches: "Aucun résultat",
        consent: "En cliquant sur le bouton, vous consentez au traitement de vos données personnelles conformément à la politique de confidentialité, y compris la collecte, la conservation et l'utilisation des informations fournies afin de vous contacter et de vous transmettre les informations nécessaires.",
        send: "Envoyer",
        contactUs: "Contactez-nous",
        yourMessage: "Votre message",
        agreeData: "J'accepte de fournir mes données afin de recevoir une réponse à ma demande d'information.",
        agreeContact: "Je demande à être informé(e) et j'accepte d'être contacté(e) par la société responsable de la promotion ou par le commercialisateur concerné, au moyen de mes coordonnées, que je fournis volontairement à cette fin.",
        reject: "Rejeter",
        like: "J'aime",
        liked: "Enregistré",
        rejected: "Rejeté",
        offerRejected: "Offre rejetée",
        contact: "Contact",
        call: "Appeler",
        calling: "Appel à",
        noPhone: "Aucun numéro disponible",
        enquirySent: "Demande envoyée — nous contacterons",
        yourDetails: "vos coordonnées",
        respondedTo: "traitées",
        noProperties: "Aucun bien à afficher.",
        soldOutBody: "Les biens de cette offre ont été vendus ou ne sont plus sur le marché. Veuillez contacter l'agence pour une sélection mise à jour.",
        expiredTitle: "Ce lien d'offre a expiré",
        expiredBody: "Veuillez contacter l'agence pour obtenir un lien à jour permettant de consulter ces biens.",
        unavailableTitle: "Offre indisponible",
        unavailableBody: "Nous n'avons pas pu charger cette offre. Le lien est peut-être invalide ou le service temporairement indisponible — veuillez réessayer plus tard ou contacter l'agence.",
    },
    title: "Propriétés de {agencyName}",
    in: "dans",
    propertiesFound: "propriétés trouvées",
    toDay: "Aujourd'hui",
    days: "journées",
    week: "Semaine",
    year: "An",
    month: "Mois",
    prev: "Précédente",
    next: "Suivante",
    backToList: "Retour à la liste",
    sorry: "Désolé nous",
    cantFind: "ne trouve pas",
    lookingFor: "la page que vous recherchez ...",
    thankYou: "MERCI DE VISITER NOTRE SITE",
    pleaseContact: "Veuillez contacter l'agent pour une nouvelle URL.",
    ForSale: "VENTE",
    ShortTermRental: "Location courte",
    LongTermRental: "Loyer long",
    showMore: "Montre plus",
    showLess: "Montrer moins",
    price: "Prix",
    pricePer: "Prix par",
    built: "Construire",
    floorSpace: "Espace intérieur",
    terrace: "Terrasse",
    garden: "Jardin",
    plot: "Tracé",
    propTitle: '{subType} {searchType} à {location}',
    propTitleShort: '{subType} à {location}',
    notAvailable: "Non disponible",
    notFound: 'Page non trouvée',
    emptyProperties: "Aucune propriété n'a été trouvée, veuillez contacter votre agent pour plus d'informations.",
    linkExpired: "Oups, ce lien a expiré. Communiquez avec votre agent immobilier pour recevoir un lien immobilier mis à jour.",
    newDevelopment: "Nouveau développement",
    agencyRaiiNo: "Numéro d'enregistrement de l'agence",
    home: {
        verifyYourURLHere: "Vérifiez votre URL ici. Pour ce faire, connectez-vous à WhatsApp sur votre navigateur Web, puis copiez l'URL de WhatsApp ici.",
        pasteUrlHere: "Coller l'URL ici",
        verifyUrl: "Vérifier l'URL",
        whatIsPropertyViewer: "Qu'est-ce que Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Ce site Web est utilisé par les agents immobiliers pour envoyer des propriétés à leurs clients. Il s'agit d'un produit de {resalesonlinecom} En cas de doute, veuillez vous adresser à l'agent qui vous a envoyé votre liste de propriétés.",
        howDoesItWork: "Comment cela fonctionne-t-il?",
        inThePast: "Dans le passé, les agents envoyaient des documents PDF à leurs clients. Cependant, ceux-ci ne sont pas faciles à afficher sur de nombreux appareils. Par conséquent, nous avons {propertyviewercom} afin que le client puisse plus facilement voir les propriétés qui leur sont envoyées.",
        createAShortList: "L’agent va créer une courte liste de propriétés. Quand ils partagent ces propriétés avec vous, vous recevrez un lien. En cliquant sur ce lien vous montrera les propriétés."
    },

    list: {
        propertyTitle: "Cliquez ici pour voir les informations pour cette propriété"
    },

    searchType: {
        ForSale: "à vendre",
        ShortTermRental: "à louer à court terme",
        LongTermRental: "à louer à long terme",
    },

    rsStatus: {
        Available: "Disponible",
        Listing: "Listage",
        UnderOffer: "Sous Offre",
        SaleAgreed: "Vente convenue",
        OffMarket: "Hors marché",
        Sold: "Vendu",
        Rented: "Loué"
    },

    details: {
        average: "Moyenne",
        averagePricesFor: "Prix moyens pour",
        showFullER: "Afficher complet",
        thisProperty: "Cette propriété",
        infoNotAvailable: "Ces informations ne sont pas disponibles.",
        feesEnergyRating: "Frais, Cote Énergétique",
        fees: "Frais",
        ibiFees: "Frais IBI",
        basuraTax: "Taxe Basura",
        communityFees: "Frais de communauté",
        associatedCosts: "Coûts associés",
        energyRating: "Classe énergétique",
        securityDeposit: "Dépôt de garantie",
        energyCertificate: "Certificat énergétique",
        energyCertificatePending: "Le certificat énergétique est en attente",
        energyConsumption: "Consommation d'énergie",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² par an",
        kwhPerYear: "kWh/m² par an",
        other: "Autrui",
        buildYear: "Année de construction",
        forSale: "À vendre",
        sold: "Vendu",
        longTerm: "Long terme",
        shortTermHigh: "Élevé à court terme",
        shortTermLow: "Bas à court terme",
        allFeatures: "Toutes les fonctionnalités",
        aproxLocation: "Aprox. Emplacement",
        listingAgent: "Agent inscripteur",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Numéro d'enregistrement touristique",
        agencyInformation: "Renseignements sur l’agence",
    },
};